import { Button } from "ui/button/button";
import { Chip } from "ui/chip/chip";
import { mergeSx } from "ui/merge-sx";
import { Stack } from "ui/stack/stack";
import { Typography } from "ui/typography/typography";
import {
  APPLIED_FILTERS_ROOT_SX,
  APPLIED_FILTERS_TITLE_SX,
} from "ui/data-grid/components/applied-filters/applied-filters.styles";
import { type AppliedFiltersProps } from "ui/data-grid/components/applied-filters/applied-filters.types";

export const AppliedFilters = ({
  items,
  onRemove,
  onClearAll,
  title = "Applied filters:",
  clearAllTestId,
  sx,
  ...rest
}: AppliedFiltersProps) => (
  <Stack {...rest} direction="row" sx={mergeSx(APPLIED_FILTERS_ROOT_SX, sx)}>
    <Typography component="span" variant="inherit" sx={APPLIED_FILTERS_TITLE_SX}>
      {title}
    </Typography>
    {items.map((item) => (
      <Chip
        key={item.id}
        size="small"
        variant="outlined"
        label={item.label}
        onDelete={() => onRemove(item.id)}
      />
    ))}
    <Button data-testid={clearAllTestId} size="small" variant="outlined" onClick={onClearAll}>
      Clear all
    </Button>
  </Stack>
);
